module.exports = __webpack_public_path__ + "img/1.b877f475.png";